import { sortByKey } from "@notemeal/utils-sort";
export const getExchangePickList = (exchangeServingList, pickListServingIds) => {
    const sortedServingAmounts = sortByKey(exchangeServingList.servingAmounts, "position");
    if (pickListServingIds === null) {
        return sortedServingAmounts;
    }
    else {
        return sortedServingAmounts.filter(sa => pickListServingIds.includes(sa.serving.id));
    }
};
//# sourceMappingURL=utils.js.map